import { render, staticRenderFns } from "./copy-url-modal.vue?vue&type=template&id=7510b7da"
import script from "./copy-url-modal.vue?vue&type=script&lang=js"
export * from "./copy-url-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports